<template>
  <main-breadcrumb
    :items="items"
    showBackButton
  ></main-breadcrumb>
  <main-buttons-bar :align="'space-between'">
    <template #left>
      <custom-title>Detalle de usuario</custom-title>
    </template>
    <template #right>
      <el-button
        type="primary"
        size="default"
        :icon="IconEdit"
        @click="editItem"
        >Editar</el-button
      >
      <home-delete-button></home-delete-button>
    </template>
  </main-buttons-bar>

  <detail-container>
    <el-row :gutter="20">
      <custom-data
        :label="'Código'"
        :spanColumn="4"
        :data="user.Codigo"
      ></custom-data>
      <custom-data
        :label="'Usuario '"
        :spanColumn="4"
        :data="user.Usuario"
      ></custom-data>
      <custom-data
        :label="'Fecha creacion'"
        :spanColumn="4"
        :data="user.FechaCreacion ? getDate('dd/mm/yyyy', user.FechaCreacion) : ''"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Nombre'"
        :spanColumn="4"
        :data="user.Nombre"
      ></custom-data>
      <custom-data
        :label="'Apellido'"
        :spanColumn="4"
        :data="user.Apellido"
      ></custom-data>
      <custom-data
        :label="'Activo'"
        :spanColumn="4"
        :data="user.Activo === true ? 'Si' : 'No'"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Roles'"
        :spanColumn="20"
        :data="user.roles_concat"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'% Comisión'"
        :spanColumn="4"
        :data="user.Comision !== null ? `${user.Comision}%` : '-'"
      ></custom-data>
    </el-row>
    <el-row :gutter="20">
      <custom-data
        :label="'Usuarios relacionados'"
        :spanColumn="20"
        :data="relacionadosDescripcion"
      ></custom-data>
    </el-row>
  </detail-container>
</template>

<script setup>
import {
  onBeforeMount,
  computed,
} from 'vue';
import { useUserStore } from '../stores/user_store.js';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconEdit from '~icons/mdi/edit';
import getDate from '@/shared/components/utils.js';

const userStore = useUserStore();
const { findUserByCodigoHTTP, loadUsuariosDisponibles } = userStore;
const { user, usuariosDisponibles } = storeToRefs(userStore);

const route = useRoute();
const router = useRouter();
// local state
const items = [
  { label: 'Inicio', to: '/page/users/list', replace: false },
  { label: 'Detalle', to: null, replace: false },
];

const relacionadosDescripcion = computed(() => {
  if (!user.value.UsuariosRelacionados || user.value.UsuariosRelacionados.length === 0) {
    return '-';
  }
  const relacionados = usuariosDisponibles.value.filter((u) =>
    user.value.UsuariosRelacionados.includes(u.Codigo),
  );
  return relacionados.map((u) => u.Descripcion).join(', ');
});

const editItem = () => router.replace(`/page/users/edit/${route.params.id}`);

onBeforeMount(() => {
  if (!usuariosDisponibles.value.length) {
    loadUsuariosDisponibles();
  }
  const id = route.params.id;
  if (id && +id > 0) {
    findUserByCodigoHTTP(id);
  }
});
</script>

<style scoped></style>
